export default __webpack_public_path__ + "static/baoluu-6bf6f959e3c34542f55e7693e47d763c.jpg";